import { forwardRef } from "react";
import { cn } from "@/lib/cn";

export const Input = forwardRef(function Input({ className, ...props }, ref) {
  return (
    <input
      ref={ref}
      className={cn(
        "h-10 w-full rounded-md border border-input bg-surface px-3 text-sm text-foreground " +
          "font-sans placeholder:text-muted-foreground transition-colors " +
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:border-primary " +
          "disabled:opacity-50",
        className
      )}
      {...props}
    />
  );
});

export function Label({ className, ...props }) {
  return (
    <label
      className={cn(
        "block text-[13px] font-medium text-foreground font-sans mb-1.5",
        className
      )}
      {...props}
    />
  );
}
